import { Grid, Typography } from "@mui/material";

import { RowBase, RowChoiceProps } from "./RowBase";

export function RowImage({ answer, meta }: RowChoiceProps) {
    return (
        <RowBase question={answer.question}>
            {answer.files.length > 0 ? (
                <Grid container spacing={3}>
                    {answer.files.map(file => (
                        <Grid item xs={12 / meta.imageColumns}>
                            <img
                                src={file.accessUrl}
                                alt="Toegevoegde foto"
                                decoding="async"
                                loading="lazy"
                                style={{ width: "100%" }}
                            />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Typography>Geen foto's toegevoegd</Typography>
            )}
        </RowBase>
    );
}
